// API Configuration
const API_CONFIG = {
  development: {
    baseURL: 'http://localhost:3001'
  },
  production: {
    // Empty baseURL means same origin (frontend and backend served together from GCP Cloud Run)
    baseURL: ''
  }
};

const environment = process.env.NODE_ENV || 'development';
export const API_BASE_URL = API_CONFIG[environment].baseURL;
